const convertTimingsToCSS = (timings) => ({
    '--timings-fast': `${timings.Fast}ms`,
    '--timings-default': `${timings.Default}ms`,
    '--timings-medium': `${timings.Medium}ms`,
    '--timings-long': `${timings.Long}ms`,
    '--timings-heavy': `${timings.Heavy}ms`,
});
const Timings = {
    Fast: 'var(--timings-fast)',
    Default: 'var(--timings-default)',
    Medium: 'var(--timings-medium)',
    Long: 'var(--timings-long)',
    Heavy: 'var(--timings-heavy)',
};
// test version

export { Timings, convertTimingsToCSS };
